import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-amzn-athena-checklist',
  templateUrl: './help-amzn-athena-checklist.component.html',
  styleUrls: ['./help-amzn-athena-checklist.component.scss']
})
export class HelpAmznAthenaChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
